<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <DxToolbar class='select-group'>
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>년도 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxYearOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>월 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxMonthOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        v-if="isMaterialType"
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>거래처 : </b></div>
      </DxItem>
      <DxItem
        v-if="isMaterialType"
        :options="selectBoxVendorOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        v-if="isMaterialType"
        :options="buttonOption"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
      />
    </DxToolbar>
    <DxPivotGrid
      ref="refPivot"
      :allow-sorting-by-summary="true"
      :allow-sorting="true"
      :allow-filtering="true"
      :allow-expand-all="true"
      :show-borders="true"
      :show-column-grand-totals="false"
      :show-row-grand-totals="true"
      :show-row-totals="false"
      :show-column-totals="true"
      :data-source="dataSource"
      :height='pivotHeight'
      @cell-prepared = 'onCellPrepared'
      @exporting="onExporting"
    >
      <DxFieldChooser
        :enabled="false"
        :height="400"
      />
      <DxExport
        :enabled="true"
        :file-name="excelTitle"
      />
    </DxPivotGrid>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import { DxPivotGrid, DxFieldChooser, DxExport } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'

// excel
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'

export default {
  name: 'monthSummary',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      thisYear: null,
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      selectBoxVendorOptions: null,
      selectedMonth: null,
      selectedVendor: 'ALL',
      dailyStatus: null,
      dataSource: null,
      excelTitle: null,
      company: 'ALL',
      pivotHeight: null,
      총합계금액: null
    }
  },
  props: {
    pType: {
      type: String,
      default: ConstDef.구매품
    },
    materialType: {
      type: String,
      default: null
    }
  },
  components: {
    Loading,
    DxPivotGrid,
    DxFieldChooser,
    DxToolbar,
    DxItem,
    DxExport
  },
  computed: {
    isMaterialType () {
      return (this.pType === ConstDef.구매품 && this.materialType !== ConstDef.자재유형_원자재 && this.materialType !== ConstDef.외주품)
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {
    this.init()
    this.pivotHeight = (screen.height - 250) * 0.9
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      // FILTER 기능을 넣을수 있습니다
      // worksheet.autoFilter = {
      //   from: 'D2',
      //   to: 'AH2'
      // }
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          console.log(excelCell)
          if (excelCell._row._number === 2) {
            excelCell.style.height = 3000
          }
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
          if (excelCell._value.model.value === '총합계') {
            excelCell._value.model.value = `총 합계금액             :         ${this.총합계금액}`
            Object.assign(excelCell, { font: { color: { argb: '0000FF' }, bold: false } })
          }
          if (excelCell._column._number === 3) {
            if (excelCell._value.model.value !== null) {
              Object.assign(excelCell, { font: { color: { argb: '0000FF' }, bold: false } })
            }
          }
          if (AppLib.isDataCell(pivotCell) || AppLib.isTotalCell(pivotCell) || AppLib.isCostTotalCell(pivotCell)) {
            const appearance = this.getConditionalAppearance(pivotCell)
            Object.assign(excelCell, this.getExcelCellFormat(appearance))
          }
          const borderStyle = { style: 'thin', color: { argb: 'FF7E7E7E' } }
          excelCell.border = {
            bottom: borderStyle,
            left: borderStyle,
            right: borderStyle,
            top: borderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}-${this.company}.xlsx`)
        })
      })
      e.cancel = true
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.$store.commit('deleteInoutList')
          this.thisYear = args.value
          this.$emit('refresh-input-vendor-list', `${this.thisYear + '-' + this.selectedMonth}`)
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.$store.commit('deleteInoutList')
          this.selectedMonth = args.value
          this.$emit('refresh-input-vendor-list', `${this.thisYear + '-' + this.selectedMonth}`)
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }
      }
      if (this.pType === ConstDef.구매품 && this.materialType !== ConstDef.자재유형_원자재) {
        tempArray = this.$Q.extend(true, [], this.$store.getters.getPartnersInfo)
        tempArray.unshift({ 거래처명: 'ALL', 거래처코드: 'ALL' })
        this.selectBoxVendorOptions = {
          width: 100,
          items: tempArray,
          valueExpr: '거래처코드',
          displayExpr: '거래처명',
          value: this.selectedVendor,
          onValueChanged: (args) => {
            this.selectedVendor = args.value
            if (this.selectedVendor !== 'ALL') {
              this.company = this.$_.findWhere(this.$store.getters.getCompanyInfo, { 거래처코드: this.selectedVendor }).거래처명
            } else {
              this.company = this.selectedVendor
            }
            this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
          }
        }
      }
      this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
    },
    onCellPrepared (e) {
      if (e.cell.type === 'GT') {
        this.$Q(e.cellElement).find('span').html(`총 합계금액 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${this.총합계금액}(원)`)
        this.$Q(e.cellElement).find('span').css('color', 'blue')
      }
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
      }
      if (e.area === 'row') {
        if (e.cell.text.includes('금액')) this.$Q(e.cellElement).find('span').css('color', 'blue')
      }
    },
    makeDaily (dailyStatus) {
      if (dailyStatus.length === 0) {
        this.setInitDataSource()
        return
      }
      const gByPcode = this.$_.groupBy(dailyStatus, function (list) { return list.품번 })
      let totalPrice = 0
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(gByPcode)) {
        totalPrice += value[0].제품금액
      }
      this.총합계금액 = AppLib.comma(totalPrice)
      const mDay = AppLib.getMonthLastDay(this.thisYear, this.selectedMonth)
      let timeStamp
      for (let i = 1; i <= mDay; i++) {
        timeStamp = AppLib.getTimestampFromformat(this.thisYear, this.selectedMonth, i)
        let where = this.$_.findWhere(dailyStatus, { 발생일: timeStamp, 품번: dailyStatus[0].품번 })
        if (where === undefined) {
          const temp = {
            차종: dailyStatus[0].차종,
            발생일: timeStamp,
            품명: dailyStatus[0].품명,
            품번: dailyStatus[0].품번,
            그룹수량: 0,
            금액: dailyStatus[0].금액,
            규격: dailyStatus[0].규격
          }
          dailyStatus.push(temp)
        }
      }
      this.setInitDataSource()
    },
    refreshDataGridFromParent (vendorCode) {
      this.refreshDataGrid(this.thisYear, this.selectedMonth, vendorCode)
    },
    refreshDataGrid (year, month, vendorCode) {
      if (this.pType === ConstDef.구매품 && this.materialType === ConstDef.자재유형_원자재) {
        // this.dailyStatus = this.$store.getters.getMatarialInfoList(vendorCode)
        this.dailyStatus = null
      } else if (this.pType === ConstDef.구매품) {
        this.dailyStatus = this.$store.getters.getPurchaseInfoList(vendorCode)
      } else {
        this.dailyStatus = this.$store.getters.getProductOutputList(vendorCode)
      }
      this.excelTitle = `${year}-${month}`
      this.총합계금액 = 0
      if (this.dailyStatus !== null) {
        this.makeDaily(this.dailyStatus)
      } else {
        this.isLoading = true
        const param = {
          startDate: `${year}-${month}-01`,
          endDate: `${year}-${month}-${AppLib.getMonthLastDay(year, month)} 23:59:59`,
          품목유형: this.pType,
          자재유형: this.materialType,
          거래처코드: vendorCode
        }
        this.$_sp.runNoEncodeFindProc('spFindAllInOutPivotByDateAndType', param)
          .then((data) => {
            this.isLoading = false
            this.dailyStatus = this.$_sp.MakeModel(data)
            this.makeDaily(this.dailyStatus)
            this.$store.commit('savePurchaseInoutList', { data: this.dailyStatus, option: param })
            this.pivotHeight = (screen.height - 250) * 0.9
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '',
            dataField: '차종',
            area: 'row',
            width: '40',
            expanded: true
          },
          {
            caption: '',
            dataField: '품번',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '',
            dataField: '규격',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '',
            dataField: '금액',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'day'
          },
          {
            caption: '수량',
            dataField: '그룹수량',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }

        ],
        store: this.dailyStatus
      })
    },
    getExcelCellFormat ({ fill, font, bold }) {
      return {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: fill } },
        font: { color: { argb: font }, bold }
      }
    },
    getConditionalAppearance (cell) {
      if (AppLib.isCostTotalCell(cell)) {
        return { font: '001aff', fill: 'ffffff', bold: false }
      }
      if (AppLib.isTotalCell(cell)) {
        return { fill: 'F2F2F2', font: '3F3F3F', bold: true }
      }
      // const { value } = cell
      // if (value > 0 && value <= 100) { // red
      //   return { font: '9C0006', fill: 'FFC7CE' }
      // } else if (value <= 500) { // yellow
      //   return { font: '9C6500', fill: 'FFEB9C' }
      // } else if (value > 500) { // green
      //   return { font: '006100', fill: 'C6EFCE' }
      // } else {
      //   return { font: '000000', fill: 'ffffff' }
      // }
      return { font: '000000', fill: 'ffffff' }
    }
  }
}
</script>

<style lang="scss">

</style>
